import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientAuthService } from '../../services/auth/client-auth.service';
import { NotificationService, Utilities } from 'reg-hub-common';
import { switchMap } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CallbackComponent {
  private readonly transloco = inject(TranslocoService);
  constructor(private _authService: ClientAuthService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _notificationService: NotificationService) { }
  ngOnInit(): void {
    this._route.queryParams.pipe(
      switchMap(params => {
        const message = params['message'];
        if (message) {
          this._notificationService.addNotification({
            id: 0,
            header: this.transloco.translate('auth.notification'),
            body: decodeURIComponent(message),
          });
        }
        if (this._authService.isLoggedIn()) {
          const returnUrl = sessionStorage.getItem('returnUrl') || '/dashboard';

          const sanitizedUrl = Utilities.sanitizeRelativeURL(returnUrl, "client");
          // clear item from session storage
          sessionStorage.removeItem('returnUrl');

          this._router.navigateByUrl(sanitizedUrl);
        }
        return [];
      })
    ).subscribe();
  }
}
